const $ = require('../../vendor/node_modules/jquery'); window.jQuery = $; window.$ = $;
require('../../vendor/jquery-cookie/1.4.1/jquery.cookie.min.js');
require('../../vendor/node_modules/jquery.easing/jquery.easing.min.js');
$.ajaxSetup({
    cache:  true,
    async:  true,
    beforeSend: function (jqXHR, settings) {
        if (settings.type === 'POST' || settings.type === 'PUT') {
            jqXHR.setRequestHeader('X-CSRF-TOKEN', $.cookie('XSRF-TOKEN'));
        }
    }
});
